import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ChangePasswordRoute } from './routes/change_password';
import { PopupLoginRoute } from './routes/popup_login';
import { PopupRegisterRoute } from './routes/popup_register';
import { RedirectLoginRoute } from './routes/redirect_login';
import { RedirectRegisterRoute } from './routes/redirect_register';
import { WelcomeRequestRoute } from './routes/welcome_request';
import { WelcomeSetPasswordRoute } from './routes/welcome_set_password';

/**
 * Auth-origin app entry. Renders only inside `login.update-fitness.ch`.
 *
 * User-facing routes:
 *   /popup/login     — username-less or username-bound assertion via postMessage
 *   /popup/register  — credential enrollment via postMessage
 *   /redirect/login  — fallback for mobile / popup-blocked browsers
 *   /redirect/register — same, registration variant
 *   /welcome         — initial-register request form (customer self-service)
 *   /welcome/set-password — initial-register token landing (set first password)
 *   /change-password — password-reset token landing (set a new password)
 *
 * Anything else 404s — keeps the surface tight.
 */

function NotFound() {
  return (
    <div style={{ padding: '24px', fontFamily: 'system-ui, sans-serif' }}>
      <h1>404</h1>
    </div>
  );
}

const router = createBrowserRouter([
  { path: '/popup/login', element: <PopupLoginRoute /> },
  { path: '/popup/register', element: <PopupRegisterRoute /> },
  { path: '/redirect/login', element: <RedirectLoginRoute /> },
  { path: '/redirect/register', element: <RedirectRegisterRoute /> },
  { path: '/welcome', element: <WelcomeRequestRoute /> },
  { path: '/welcome/set-password', element: <WelcomeSetPasswordRoute /> },
  { path: '/change-password', element: <ChangePasswordRoute /> },
  { path: '*', element: <NotFound /> },
]);

export function App() {
  return <RouterProvider router={router} />;
}
